import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

const StyledVoiceCardItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px;
  border-radius: 12px;
  box-shadow: 0 2px 16px 0 ${COLOR.black[8]};
  box-sizing: border-box;
  height: 96px;
  background: ${(props) =>
    props.isActive ? COLOR.backgroundActiveVoice : COLOR.white};
  border: 1px solid
    ${(props) => (props.isActive ? COLOR.borderActiveVoice : 'transparent')};
  ${(props) =>
    props.isAudioPlaying &&
    `
      animation: backgroundTransition 2s ease-in-out infinite alternate;
      border: 1px solid ${COLOR.indigo.default};
      box-sizing: border-box;
    `}
  &:hover {
    border-radius: 12px;
    background: ${(props) =>
      props.isActive ? COLOR.backgroundActiveVoice : COLOR.grayV2[50]};
    cursor: pointer;
  }

  .voice-card-info-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    flex: 1;
    min-width: 0;
  }

  .voice-card-value {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 52px;
  }

  @keyframes backgroundTransition {
    0% {
      background-color: #ebebed;
    }
    25% {
      background-color: #e5e5e8;
    }
    50% {
      background-color: #e7e7ea;
    }
    75% {
      background-color: #e0e0e4;
    }
    100% {
      background-color: #f4f4f5;
    }
  }
`;

export { StyledVoiceCardItem };
